import { render, staticRenderFns } from "./Tab.component.vue?vue&type=template&id=fb5fff90&scoped=true"
import script from "./Tab.component.vue?vue&type=script&lang=js"
export * from "./Tab.component.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fb5fff90",
  null
  
)

export default component.exports